import { render, staticRenderFns } from "./box.vue?vue&type=template&id=2b4e9731"
import script from "./box.ts?vue&type=script&lang=js&external"
export * from "./box.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b4e9731')) {
      api.createRecord('2b4e9731', component.options)
    } else {
      api.reload('2b4e9731', component.options)
    }
    module.hot.accept("./box.vue?vue&type=template&id=2b4e9731", function () {
      api.rerender('2b4e9731', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/child/containers/box.vue"
export default component.exports